// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"layers"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.5 6.125L12 3L19.5 6.125L12 9.25L4.5 6.125Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.5 6.125L12 3L19.5 6.125L12 9.25L4.5 6.125Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 11.5005L12 15.3771L21 11.5005M21 17.5005L12 21.3771L3 17.5005","strokeWidth":"props.strokeWidth"}}]}]};

const LayersIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'layers',
    ref,
    icon: element,
  },
));

LayersIcon.displayName = 'LayersIcon';

export default LayersIcon;
